var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.path,class:['sr-documentation' ].concat( _vm.classes),domProps:{"innerHTML":_vm._s(_vm.parsed)}})}
var staticRenderFns = []

export { render, staticRenderFns }